import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-base',
  standalone: false,
  templateUrl: './base.component.html',
  styleUrl: './base.component.less',
})
export class BaseLayoutComponent implements OnInit {
  isLoggedIn: boolean = false;
  isSidebarOpen = false;

  constructor(private authService: AuthService) {}
  ngOnInit() {
    this.authService.isLoggedIn();
  }
  toggleSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen;
  }
}
